import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '@core/http';
import {
  IProcedureComboQuery,
  ProcedureProtocol,
} from '../../../project/modules/session-details-shared/session-details-shared-medical-record/interfaces/procedures';
import { environment } from '@env';

@Injectable({
  providedIn: 'root',
})
export class ProceduresCombosService {
  constructor(private readonly apiService: ApiService) {}

  getProcedureCombos(query?: IProcedureComboQuery): Observable<ProcedureProtocol[]> {
    const url = `${environment.environmentVariables.apiCoreUrl}/ProcedureCombo`;

    return this.apiService.get<ProcedureProtocol[]>(url, query);
  }
}
